import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "../css/layout.css";
// import Redes from "../components/Redes"

const Layout = (props) => {
  return (
    <div className="app-layout">
      <NavBar />

      <main className="app-main">
        {props.children}
      </main>

      <Footer />

      {/* <Redes /> */}
    </div>
  );
};

export default Layout;
